"use strict";var regexpExec=require("./_regexp-exec");require("./_export")({target:"RegExp",proto:!0,forced:regexpExec!==/./.exec},{exec:regexpExec});